export enum VehicleStatusType {
  DISPONIBLE = 'DISPONIBLE',
  INDISPONIBLE = 'INDISPONIBLE',
  SOLD = 'SOLD',
}

export const VehicleStatusTypeColor = {
  [VehicleStatusType.INDISPONIBLE]: '#DB0032',
  [VehicleStatusType.DISPONIBLE]: '#A2D45E',
  [VehicleStatusType.SOLD]: '#FED925',
};

export const VehicleStatusTypeText = {
  [VehicleStatusType.DISPONIBLE]: 'Disponível',
  [VehicleStatusType.INDISPONIBLE]: 'Indisponível',
  [VehicleStatusType.SOLD]: 'Vendido',
};

export type Results = {
  id: number,
  name: string,
  brand: string,
  batchId: number,
  km: number,
  price: number,
  fipePrice: number,
  year: number,
  yearModel: number,
  licensePlate: string,
  status: VehicleStatusType,
  color: string,
  gpId: string,
  orderId: number,
}

export interface IVehicle {
  results: Results[];
  total: number;
}

export enum enTranslateTransmission {
  'manual' = 'manual',
  'automatic' = 'automático',
}

export enum enTranslateColor {
  'white' = 'branco',
  'black' = 'preto',
  'gray' = 'cinza',
  'silver' = 'prata',
  'red' = 'vermelho',
  'blue' = 'azul',
  'brown' = 'marrom',
  'green' = 'verde',
  'beige' = 'bege',
  'orange' = 'laranja',
  'gold' = 'dourado',
  'yellow' = 'amarelo',
  'purple' = 'roxo',
}

export enum enTranslateFuel {
  'gasoline' = 'gasolina',
  'ethanol' = 'álcool',
  'flex' = 'gasolina e álcool',
}

export enum enTranslateSteering {
  'hydraulic' = 'hidráulico',
  'eletric' = 'elétrico',
  'hydraulicEletric' = 'hidráulico e elétrico',
}

export enum enBrand {
  'fiat' = 'fiat',
  'mercedes' = 'mercedes',
  'mercedes benz' = 'mercedes benz',
  'honda' = 'honda',
  'ford' = 'ford',
  'hyundai' = 'hyundai',
  'toyota' = 'toyota',
  'chevrolet' = 'chevrolet',
  'nissan' = 'nissan',
  'audi' = 'audi',
  'jeep' = 'jeep',
  'peugeot' = 'peugeot',
  'volvo' = 'volvo',
  'renault' = 'renault',
  'mitsubishi' = 'mitsubishi',
  'volkswagen' = 'volkswagen',
  'caoa chery' = 'caoa chery'
}

export type VehicleProps = {
  name: string,
  brand: string,
  price: number,
  fipePrice: number,
  year: number,
  yearModel: number,
  ports: number,
  km: number,
  color: string,
  transmission: string,
  steering: string,
  fuel: string,
  observations: string,
  accessories: string,
  thumbnail: string,
  image: string[],
  emailImage: string,
  firstDocument: string,
  secondDocument: string,
  inpectionCode: string,
  licensePlate: string,
}
